<template>
    <div>
      <router-view></router-view>
      <AdminFooter></AdminFooter>
    </div>
</template>

<script>
import AdminFooter from "@/components/admin/AdminFooter";
import global from "@/mixins/global";

export default {
  mixins: [global],
  mounted() {
    this.loadUser()
    if(!localStorage.getItem("token")){
      this.$router.push("/login")
    }
  },
  name: "AdminHome",
  components: {AdminFooter},
  computed: {
    stateuser(){
      return this.$store.getters.user
    }
  }
}
</script>

<style scoped>

</style>